import React from 'react';
import classNames from 'classnames';

export default function LaptopIcon({ className = '' }) {
	return <span className={classNames('icon icon-business_centre', className)} />;
}
